import { createAsyncThunk } from "@reduxjs/toolkit";
import imageApi from 'api/imageApi';
import { formatQueryParams } from "helpers/format";

export const getImageCategories = createAsyncThunk("Image Categories", async (params: any = {}) => {
  try {
    const response = await imageApi.imageCategories(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
});

export const getAllImageCategory = async (params: any = {}) => {
  try {
    const response = await imageApi.allImageCategory(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getImageCategory = async (id: string | number, params: any = {}) => {
  try {
    const response = await imageApi.getImageCategory(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postImageCategory = async (data: any = {}) => {
  try {
    const response = await imageApi.postImageCategory(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putImageCategory = async (id: string | number, data: any = {}, DEPTH_CATEGORY: number = 0) => {
  try {
    if (DEPTH_CATEGORY === 2) {
      const response = await imageApi.putImageCategory(id, data);
      return response;
    }

    const response = await imageApi.putImportImageCategory(id, data);
    return response;

  } catch (error) {
    return error;
  }
};

export const putImportImageCategoryLevel1 = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.putImportImageCategoryLevel1(id, data);
    return response;

  } catch (error) {
    return error;
  }
};


export const postSiteImageCategory = async (data: any = {}) => {
  try {
    const response = await imageApi.postSiteImageCategory(data);
    return response;
  } catch (error) {
    return error;
  }
};



export const deleteImageCategory = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.deleteImageCategory(id, data);
    return response;
  } catch (error) {
    return error;
  }
};


export const getImageSearchByCategory = async (params: any = {}) => {
  try {
    const response = await imageApi.getImageSearchByCategory(params)
    return response;
  } catch (error) {
    return error;
  }
};


export const postConvertToCdn = async (data: any = {}) => {
  try {
    const response = await imageApi.postConvertToCdn(data);
    return response;
  } catch (error) {
    return error;
  }
};



// Image Library

export const getImageLibraryNormal = async (params: any = {}) => {
  try {
    const response = await imageApi.imageLibraries(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllImageLibraryTags = async (params: any = {}) => {
  try {
    const response = await imageApi.getAllImageLibraryTags(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getImageLibrary = async (id: string | number, params: any = {}) => {
  try {
    const response = await imageApi.getImageLibrary(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postImageLibrary = async (data: any = {}) => {
  try {
    const response = await imageApi.postImageLibrary(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putImageLibrary = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.putImageLibrary(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteImageLibrary = async (data: any = {}) => {
  try {
    const response = await imageApi.deleteImageLibrary(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const importImageBulkByExcel = async (data: any = {}) => {
  try {
    const response = await imageApi.importImageBulkByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleImageBulkExcel = async (params: any = {}) => {
  try {
    const response = await imageApi.getTemplateSampleImageBulkExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const patchImageLibrary = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.patchImageLibrary(id, data);
    return response;
  } catch (error) {
    return error;
  }
};



// Image Public

export const getImagePublicsNormal = async (params: any = {}) => {
  try {
    const response = await imageApi.imagePublics(formatQueryParams(params))
    return response;
  } catch (error) {
    return error;
  }
};

export const getAllImagePublicTags = async (params: any = {}) => {
  try {
    const response = await imageApi.getAllImagePublicTags(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const getImagePublic = async (id: string | number, params: any = {}) => {
  try {
    const response = await imageApi.getImagePublic(id, params)
    return response;
  } catch (error) {
    return error;
  }
};

export const postImagePublic = async (data: any = {}) => {
  try {
    const response = await imageApi.postImagePublic(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const putImagePublic = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.putImagePublic(id, data);
    return response;
  } catch (error) {
    return error;
  }
};

export const deleteImagePublic = async (data: any = {}) => {
  try {
    const response = await imageApi.deleteImagePublic(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const importImagePublicBulkByExcel = async (data: any = {}) => {
  try {
    const response = await imageApi.importImagePublicBulkByExcel(data);
    return response;
  } catch (error) {
    return error;
  }
};

export const getTemplateSampleImagePublicBulkExcel = async (params: any = {}) => {
  try {
    const response = await imageApi.getTemplateSampleImagePublicBulkExcel(params)
    return response;
  } catch (error) {
    return error;
  }
};

export const patchImagePublic = async (id: string | number, data: any = {}) => {
  try {
    const response = await imageApi.patchImagePublic(id, data);
    return response;
  } catch (error) {
    return error;
  }
};